import {
    AbstractControl,
    ValidatorFn
} from '@angular/forms';
import { IDatiqAutocompleteOption } from '../models';

export const PATTERN_ERROR_KEY: string = 'autocompletePattern';

export function isValidOption(
    pattern: string,
    option: IDatiqAutocompleteOption
): boolean {
    return new RegExp(pattern, 'gm').test(option.display);
}

export function patternCheck(
    pattern: string,
    options: IDatiqAutocompleteOption[]
) {
    const valid: boolean = options.every(
        (option: IDatiqAutocompleteOption): boolean => {
            return isValidOption(pattern, option);
        }
    );

    return !valid
        ? {
              [PATTERN_ERROR_KEY]: {
                  pattern,
              },
          }
        : null;
}

export const pattern: (pattern: string) => ValidatorFn = (pattern: string) => {
    return (control: AbstractControl): { [key: string]: any } | null => {
        return patternCheck(pattern, control.value ?? []);
    };
};
